module.exports = __webpack_public_path__ + "img/maintenance.fdf84f1e.svg";